import { ShoppingCart } from 'lucide-react'

type Props = { props: Record<string, string | number | boolean> }

export function ProductOfferPreview({ props: p }: Props) {
  return (
    <div className="flex items-center gap-4 p-3 bg-tf-bg-card rounded-lg border border-tf-border-sub">
      {p.imageUrl ? (
        <img src={p.imageUrl as string} alt="Product" className="w-20 h-20 object-contain rounded flex-shrink-0" />
      ) : (
        <div className="w-20 h-20 bg-tf-bg-hover rounded flex items-center justify-center flex-shrink-0">
          <ShoppingCart className="w-6 h-6 text-tf-text-muted" />
        </div>
      )}
      <div className="flex-1">
        <h4 className="font-semibold text-tf-text">{p.productName as string}</h4>
        <div className="flex items-center gap-2 mt-1">
          <span className="text-tf-text-muted line-through text-sm">${p.originalPrice as string}</span>
          <span className="text-tf-success font-bold">${p.discountedPrice as string}</span>
          {p.showBadge && (
            <span className="bg-tf-critical-lighter text-tf-critical text-xs font-bold px-1.5 py-0.5 rounded">
              {p.discountLabel as string}
            </span>
          )}
        </div>
      </div>
    </div>
  )
}
